import { IndentValues } from "@/lib/utils/IndentValues";
import { SpacingValues } from "@/lib/utils/SpacingValues";
import { Box, Space, Txt } from "@stenajs-webui/core";
import {
  Card,
  CardBody,
  CardHeader,
  PrimaryButton,
  stenaAngleRight,
} from "@stenajs-webui/elements";
import { cssColor } from "@stenajs-webui/theme";
import * as React from "react";
import { CustomerSelect } from "@/components/data-driven-inputs/selects/customer-select/CustomerSelect";
import { HeadAgreementByCustomerIdSelect } from "@/components/data-driven-inputs/selects/head-agreement-by-customer-select/HeadAgreementByCustomerSelect";
import { GridContainer } from "@/components/grid-container/GridContainer";
import { ByCustomerNumberOrIndexFragment } from "@/gql/graphql";

export interface Props {
  copyFromCustomer: ByCustomerNumberOrIndexFragment;
  copyFromHeadAgreementId: string;
  selectButtonDisabled: boolean;
  loading?: boolean;
  setCopyFromCustomer: React.Dispatch<
    React.SetStateAction<ByCustomerNumberOrIndexFragment>
  >;
  setCopyFromHeadAgreementId: React.Dispatch<React.SetStateAction<string>>;
  rightButtonOnClick: () => void;
}

export const SelectCustomerAndHaToCopyFrom: React.FC<Props> = ({
  copyFromCustomer,
  copyFromHeadAgreementId,
  selectButtonDisabled,
  loading,
  setCopyFromCustomer,
  setCopyFromHeadAgreementId,
  rightButtonOnClick,
}) => {
  return (
    <Box indent={IndentValues.TWENTYFOUR} spacing={SpacingValues.TWENTYFOUR}>
      <Card>
        <CardHeader text={"Select customer and agreement to copy from"} />
        <CardBody>
          <GridContainer boxMinWidth={370} boxMaxWidth={"370px"}>
            <Box>
              <Txt color={cssColor("--lhds-color-ui-700")}>
                Select customer to copy from
              </Txt>
              <Space />
              <CustomerSelect
                value={copyFromCustomer.id}
                onValueChange={(customer) => {
                  setCopyFromCustomer(customer);
                  setCopyFromHeadAgreementId("");
                }}
              />
            </Box>
            <Box>
              <Txt color={cssColor("--lhds-color-ui-700")}>
                Select header agreement to copy from
              </Txt>
              <Space />
              <HeadAgreementByCustomerIdSelect
                customerId={copyFromCustomer.id}
                onValueChange={(headAgreement) =>
                  setCopyFromHeadAgreementId(headAgreement.id)
                }
                value={copyFromHeadAgreementId}
                isDisabled={!copyFromCustomer.id}
              />
            </Box>

            <Box maxWidth={"200px"} justifyContent={"flex-end"}>
              <PrimaryButton
                label="Select agreements"
                rightIcon={stenaAngleRight}
                disabled={selectButtonDisabled}
                loading={loading}
                loadingLabel={"Select agreements"}
                onClick={() => rightButtonOnClick()}
              />
            </Box>
          </GridContainer>
        </CardBody>
      </Card>
    </Box>
  );
};
